const ModalActions = {
    PRINT_DIALOG: "modal/print-dialog",
    CLOSE: "modal/close",
};

export default ModalActions;



// WEBPACK FOOTER //
// ./app/controllers/ModalActions.js